import { useEffect, useState } from 'react';

import ImageCard from './assets/components/ImageCard';
import ImageSearch from './assets/components/ImageSearch';

import NavBar from './assets/components/NavBar';

function App() {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [term, setTerm] = useState('');

  const setSearchTerm = function (keyword) {
    setTerm(keyword);
  };

  useEffect(() => {
    fetch(
      `https://pixabay.com/api/?key=31950912-951a780aab74a5d88cd06bcf6&q=${term}&image_type=photo&pretty=true`
    )
      .then(async (response) => await response.json())
      .then((data) => {
        setImages(data.hits);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [term]);

  return (
    <div className="container mx-auto">
      <NavBar />
      <ImageSearch searchTerm={setSearchTerm} />
      {!isLoading && images.length === 0 && (
        <h1 className='text-5xl text-center mx-auto mt-32"'>No Images Found</h1>
      )}
      {isLoading ? (
        <h1 className="text-6xl text-center mx-auto mt-32">Loading......</h1>
      ) : (
        <div className="grid grid-1 gap-6 md:grid-cols-2 xl:grid-cols-3 lg:gap-x-12 content-center">
          {images.map((image) => {
            return <ImageCard key={image.id} image={image} />;
          })}
        </div>
      )}
    </div>
  );
}

export default App;
